import React from 'react'

export default function () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" stroke="#979797" d="M-430.5 -3108.5H1726.5V252.5H-430.5z" opacity=".05" />
        <path
          fill="#999"
          d="M24.192 5.808c.39.39.39 1.023 0 1.414l-16.97 16.97c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.023 0-1.414l16.97-16.97c.39-.39 1.024-.39 1.414 0zm-1.176 4.004c1.172.88 2.303 1.965 3.39 3.252.903 1.067.944 2.607.119 3.723l-.124.156-.3.348C22.786 21.074 19.072 23 15 23c-1.51 0-2.97-.265-4.379-.79l1.587-1.587c.911.252 1.841.377 2.792.377 3.341 0 6.433-1.548 9.305-4.7l.287-.32.287-.335c.315-.372.315-.918 0-1.29-1.067-1.263-2.164-2.3-3.293-3.113l1.43-1.43zM15 7c1.51 0 2.97.265 4.38.791l-1.587 1.587C16.882 9.125 15.951 9 15 9c-3.341 0-6.433 1.548-9.305 4.7l-.287.32-.287.335c-.315.372-.315.918 0 1.29 1.067 1.263 2.164 2.3 3.293 3.113l-1.43 1.43c-1.173-.88-2.303-1.965-3.39-3.252-.903-1.067-.944-2.607-.119-3.723l.124-.156.3-.348C7.214 8.926 10.928 7 15 7zm4.266 6.563c.152.452.234.935.234 1.437 0 2.485-2.015 4.5-4.5 4.5-.502 0-.985-.082-1.436-.234l5.702-5.703zM15 10.5c.503 0 .986.082 1.437.234l-5.702 5.704c-.153-.452-.235-.935-.235-1.438 0-2.485 2.015-4.5 4.5-4.5z"
        />
      </g>
    </svg>
  )
}
